// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const List: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39 32" enableBackground="new 0 0 39 32" xmlSpace="preserve" fill="currentColor">
<g>
	<circle cx="3.33" cy="16" r="3.12"/>
	<circle cx="3.33" cy="3.5" r="3.12"/>
	<path d="M3.33,25.73c-1.54,0-2.77,1.25-2.77,2.77c0,1.52,1.25,2.77,2.77,2.77c1.52,0,2.77-1.25,2.77-2.77
		C6.1,26.98,4.88,25.73,3.33,25.73z"/>
	<rect x="9.58" y="1.42" width="29.17" height="4.17"/>
	<rect x="9.58" y="26.42" width="29.17" height="4.17"/>
	<rect x="9.58" y="13.92" width="29.17" height="4.17"/>
</g>
</svg>;
};

export default React.memo(List);
